export const apiOriginUrl: string = 'https://api.v2.amitel.eu';
export const ceriServerUrl: string = 'https://api.amitel.eu:2323/api_amitel/';

export const environment = {
  production: true,
  local: '/assets/data',
  origin: `${apiOriginUrl}`,
  apiV1: '/api/v1/',
  service: {
    user: '/bff/service-user',
    core: '/bff/service-core'
  },
  ceriServerUrl,
  auth0: {
    domain: 'https://amitel-production.eu.auth0.com',
    clientId: 'xoTjR6dpTywOcT1qwfthqSZDcKRAgZHa',
    audience: 'https://api.v2.amitel.eu'
  },
};
